/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { MaterialReactTable } from 'material-react-table'
import { Box, Tab, Tabs, Typography, IconButton, Button } from '@mui/material'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import { getSlideoutInfo } from '../../../redux/global'
import { useParams, useLocation, Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowBack, MoreVert } from 'irmlib/icons'
import { useTheme } from 'irmlib/styles'
import * as routePaths from '../../../navigation/routePaths'
import { CancelButton } from '../../../irmlib/src/components/FormControls'
import styled from 'styled-components'
import { MenuButton } from 'irmlib/components/Controls'
import { openGeneralDialog, closeGeneralDialog } from '../../../irmlib/src/containers'
import { userRoleSuperUser } from '../../../common/constants'
import { getUserRole } from '../../../redux/global'
import { useMergeState } from 'irmlib/hooks'
import { RetakeImageBox, ReprocessImage, UpdateImageTemplate, UpdateImgRefImage, UpdateImageTemplateAndRef} from './LocalMenuActivities'
import ImageContainer from './MultiImageContainer'
import ExportCsv from '../../Controls/ExportCsv'
import { XDivider } from '../../../irmlib/src/styles'
// import { getImgFromNats } from '../../../services/nats/localNatsTransactions'
// import { useNats } from '../../../providers/NatsProvider.jsx'
import { useGetNatsImage } from '../../../services/nats/useGetNatsImage'
import * as constants from '../../../irmlib/src/common/constants.js'
import { Visibility } from '@material-ui/icons'

const JobLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`

const initialvalues = {
  columnsNew: []
}
export const LocalImageExceptionDetails = () => {
  const theme = useTheme()
  const history = useHistory()
  // const { natsService } = useNats()
  const { getImgFromNats } = useGetNatsImage()
  const handleGoBack = () => {
    history.goBack()
  }
  const { label: paramLabel } = useParams()
  const { state } = useLocation()
  const { label: stateLabel, district, building } = state || {}
  const [activeTab, setActiveTab] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [, setState, getState] = useMergeState(initialvalues)
  const { t } = useTranslation()
  const [hitlRejectData, setHitlRejectData] = useState([])
  const [idpFailureData, setIdpFailureData] = useState([])
  // const [idpSucessData, setIdpSucessData] = useState([])
  // const [submitData, setSubmitData] = useState([])
  const [failData, setFailData] = useState([])
  const [idpData, setIdpData] = useState([])
  const [formatData, setFormatData] = useState([])
  const [hitlRejectCount, setHitlRejectCount] = useState(0)
  const [idpFailureCount, setIdpFailureCount] = useState(0)
  const [idpFailData, setIdpFailData] = useState([])
  // const [submitCount, setSubmitCount] = useState(0)
  const [failCount, setFailCount] = useState(0)
  const [openReprocessImage, setOpenReprocessImage] = useState(false)
  const [openTemplateModal, setOpenTemplateModal] = useState(false)
  const [retakeImage, setRetakeImage] = useState(false)
  const [openChangeRefImg, setOpenChangeRefImg] = useState(false)
  const [openChangeTempAndRefImg, setOpenChangeTempAndRefImg] = useState(false)
  const [selectedRowData, setSelectedRowData] = useState(null)
  const [enableOptions, setEnableOptions] = useState(false)
  const [selectedImageIndex, setSelectedImageIndex] = useState(null)
  const { userName } = getSlideoutInfo()
  const handleRequestIdClick = (requestId) => {
    history.push(`/details/${requestId}`)
  }
  // const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);
  const [isLoadingImages, setIsLoadingImages] = useState(false);
  
  useEffect(() => {
    if (stateLabel === 'IDP Failure') {
      setActiveTab(1)
    }
    if (stateLabel === 'Format Error') {
      setActiveTab(2)
    }
  }, [stateLabel])

  useEffect(() => {
    const userRole = getUserRole()
    if (userRole === userRoleSuperUser) {
      setEnableOptions(true)
    }
  }, [])

  const handleClose = () => {
    setSelectedImageIndex(null)
    setSelectedImage([])
    setIsLoadingImages(false)
  }

  const handleOpen = async (index, images) => {
    if (!images || !Array.isArray(images) || images.length === 0) {
      return
    }
    
    setIsLoadingImages(true)
    setSelectedImageIndex(index)
    
    try {
      const convertedImages = await getBlobImage(images)
      setSelectedImage(convertedImages)
    } catch (error) {
      console.error('Error converting images', error)
      setSelectedImage(images) 
    } finally {
      setIsLoadingImages(false)
    }
  }
  const getBlobImage = async (images = []) => {
    if (!images || !Array.isArray(images) || images.length === 0) {
      return []
    }
    
    const result = await Promise.all(images.map(async image => {
      if (image && typeof image === 'string' && image.includes('nats')) {
        // Use LOCAL_AI_ASSET_IMG for regular captured images, not reference images
        // const blobUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, image)
        
        // --- OLD CODE ---
        // const blobUrl = await natsService.getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, image)
        
        // --- NEW CODE ---
        const blobUrl = await getImgFromNats(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_ASSET_IMG, image, true)
        
        return blobUrl || image 
      }
      return image
    }))
    return result.filter(img => img !== null && img !== undefined) // Filter out any null/undefined values
  }
  const MultiImageContainer = () => (
    <div>
      {selectedImageIndex !== null && (
        <ImageContainer
          images={selectedImage}
          selectedImageIndex={selectedImageIndex}
          handleClose={handleClose}
          isLoading={isLoadingImages}
        />
      )}
    </div>
  )
  const handleRetakeImage = (rowData) => {
    setSelectedRowData(rowData)
    setRetakeImage(true)
  }

  const handleCloseRetakeImageModal = () => {
    setRetakeImage(false)
    setSelectedRowData(null)
  }

  const handleOpenMenuItems = (rowData) => {
    setSelectedRowData(rowData)
    setOpenReprocessImage(true)
  }

  const handleCloseMenuItems = () => {
    setOpenReprocessImage(false)
    setSelectedRowData(null)
  }

  const handleOpenTemplateModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenTemplateModal(true)
  }

  const handleCloseTemplateModal = () => {
    setOpenTemplateModal(false)
    setSelectedRowData(null)
  }
  const handleOpenRefImgModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenChangeRefImg(true)
  }
  const handleCloseRefImgModal = () => {
    setOpenChangeRefImg(false)
    setSelectedRowData(null)
  }
  const handleOpenRefImgAndTempModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenChangeTempAndRefImg(true)
  }
  const handleCloseRefImgandTempModal = () => {
    setOpenChangeTempAndRefImg(false)
    setSelectedRowData(null)
  }

  const onSelect = (value, rowData) => {
    if (value === 'Retake Image') {
      handleRetakeImage(rowData)
    }
    if (value === 'Reprocess Image') {
      handleOpenMenuItems(rowData)
    }
    if (value === 'Change Template') {
      handleOpenTemplateModal(rowData)
    }
    if (value === 'Change Reference Image') {
      handleOpenRefImgModal(rowData)
    }
    if (value === 'Change Template And Reference Image') {
      handleOpenRefImgAndTempModal(rowData)
    }
  }

  const menuItems = [
    { value: 'Retake Image', id: 'createJobs_edit', label: t('Search.RetakeImage'), style: { color: theme.palette.primary.main } },
    { value: 'Reprocess Image', label: t('Search.ReprocessImage'), style: { color: theme.palette.primary.main } },
    { value: 'Change Template', label: t('Search.ChangeTemplate'), style: { color: theme.palette.primary.main } },
    { value: 'Change Reference Image', label: t('Search.ChangeRefImage'), style: { color: theme.palette.primary.main } },
    { value: 'Change Template And Reference Image', label: t('Search.ChangeTemplateAndRefImage'), style: { color: theme.palette.primary.main } },
  ]
  const menuItems2 = [
    { value: 'Retake Image', id: 'createJobs_edit', label: t('Search.RetakeImage'), style: { color: theme.palette.primary.main } },
     ]

  const tabConfigs = [
    {
      label: t('jobStatusObj.HITL Reject'),
      columns: [
        {
          accessorKey: 'requestId',
          header: 'Request ID',
          Cell: ({ cell }) => {
            const dataIndex = cell.row.index
            const rowdata = currentTabData[dataIndex]
            return (
              <JobLink
                id={`myJobs_jobLink_${rowdata.requestId}`}
                theme={theme}
                to={{
                  pathname: `${routePaths.localactivityList}/${rowdata.requestId}`,
                  state: {
                    fromAdmin: false,
                    rowData: rowdata
                  }
                }}
              >
                {rowdata.requestId}
              </JobLink>
            )
          },
        },
        { header: t('tableColumns.userName'), accessorKey: 'username' },
        {
          header: t('tableColumns.customRequestName'),
          accessorKey: 'requestName',
        },
        { header:"Asset Type" , accessorKey:"assetType"},
        { header: t('tableColumns.boxNumber'), accessorKey: 'boxId' },
        { header: t('tableColumns.barcode'), accessorKey: 'barCode' },
        { header: t('smartCatalog.orderId'), accessorKey: 'orderId' },
        { header: t('tableColumns.status'), accessorKey: 'status' },
        { header: t('tableColumns.created'), accessorKey: 'createdAt' },
        { header: t('tableColumns.published'), accessorKey: 'publishedAt' },
        { header: t('tableColumns.processed'), accessorKey: 'processedAt' },
        { header: t('dashBoard.exception'), accessorKey: 'exception' },
        {
          accessorKey: 'images',
          header: t('tableColumns.images'),
          Cell: ({ row }) => {
            const rowData = row?.original?.images // assuming `images` is an array in each row
            if (rowData && rowData?.length !== 0) {
              return (
                <Visibility
                  style={{ cursor: 'pointer', fontSize: 32 }}
                  onClick={() => {
                    handleOpen(0, rowData)
                  }} 
                />
              )
            } else {
              return null
            }
          }
        },
        { 
          header: t('smartCatalog.sequenceId'), 
          accessorKey: 'sequenceId',
          enableFiltering: true,
          filterVariant: 'multi-select', // Matches filterType: 'multiselect'
          sortingFn: (rowA, rowB) => {
            const valueA = rowA.original.sequenceId === '-' ? Infinity : rowA.original.sequenceId
            const valueB = rowB.original.sequenceId === '-' ? Infinity : rowB.original.sequenceId
            return valueA - valueB
          },
          muiTableBodyCellProps: {
            sx: {
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            },
          },
        },
        { 
          header: t('smartCatalog.range'), 
          accessorKey: 'range',
          enableFiltering: true,
          filterVariant: 'multi-select', // Matches filterType: 'multiselect'
          muiTableBodyCellProps: {
            sx: {
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            },
          },
        },
        // {
        //   header: t('tableColumns.imgReference'),
        //   accessorKey: 'imgReference',
        //   Cell: ({ cell }) => {
        //     const value = cell.getValue()
        //     if (value) {
        //       return (
        //         <img src={value} alt="Reference" style={{ width: '100px', height: '70px', cursor: 'pointer' }} onClick={() => openModal(value)} />
        //       )
        //     } else {
        //       return null
        //     }
        //   }
        // },
        enableOptions
          ? {
              accessorKey: 'modify',
              header: t('tableColumns.action'),
              Cell: ({ cell }) => {
                const dataIndex = cell.row.index
                const rowData = currentTabData[dataIndex]
                if (!rowData) return null
                let customMenuItems = []
                const isReprocess = rowData?.isReprocess ?? false
                if (rowData && 
                  (
                    (!rowData?.isProcessed && rowData?.isPublished ) || 
                    (['pending', 'In Progress'].includes(rowData?.boxStatus)) ||
                    (isReprocess)
                  )) {
                  customMenuItems = menuItems2
                } else {
                  customMenuItems = menuItems
                }
                return (
                  <MenuButton
                    id={'allJobs_ellipsis'}
                    buttonIcon={<MoreVert />}
                    rowdata={rowData}
                    items={customMenuItems}
                    onSelect={(value) => { onSelect(value, rowData) }}
                  />
                )
              }
            }
          : null
      ].filter(Boolean),
      fetchData: async () => {
        try {
          let result
          if (idpData.length === 0) {
            result = await localGdeTransactions.getrequestIdbydistandStatus(district, building, ['HITL Reject'])
          } else {
            result = idpData
          }
          
          // Run box status and request name lookups in parallel
          const boxPromise = result['HITL Reject'].Filtereddocs.map(doc => {
            const actId = doc.activityId
            return localGdeTransactions.getActivityByID(doc.activityId).then((res) => ({
              activityId: actId,
              status: res?.status
            }))
          })
          
          // Get unique request IDs to batch lookup
          const uniqueRequestIds = [...new Set(result['HITL Reject'].Filtereddocs.map(doc => doc?.requestId).filter(Boolean))]
          
          // Batch fetch all request names in parallel
          const requestNamePromises = uniqueRequestIds.map(requestId => 
            localGdeTransactions.getCustomRequestNameById(requestId).then(name => ({ requestId, name }))
          )
          
          // Wait for both in parallel
          const [allData, requestNames] = await Promise.all([
            Promise.all(boxPromise),
            Promise.all(requestNamePromises)
          ])
          
          // Create a map for quick lookup
          const requestNameMap = {}
          requestNames.forEach(({ requestId, name }) => {
            requestNameMap[requestId] = name
          })
          
          const eachBoxStatus = {}
          allData.forEach(e => {
            eachBoxStatus[e.activityId] = e.status
          })
          
          // Build data synchronously using the map
          const hitlRejectsData = result['HITL Reject'].Filtereddocs.map((doc) => {
            const rangeFromTo = doc?.rangeFrom !== undefined && doc?.rangeTo !== undefined
              ? `${doc?.rangeFrom} - ${doc?.rangeTo}`
              : '-'
            return {
              activityId: doc.activityId,
              imageId: doc.id,
              customer: doc?.accountLevel1,
              currentImageURL: doc?.imgReference,                
              requestId: doc?.requestId || 'N/A',
              username: doc?.username || 'N/A',
              requestName: requestNameMap[doc?.requestId] || 'N/A',
              assetType: doc?.assetType ||"N/A",
              boxId: doc?.skpBoxNbr || 'N/A',
              barCode: doc?.barcode || 'N/A',
              orderId: doc?.orderId || 'N/A',
              status: doc?.status || 'N/A',
              publishedAt: doc?.publishedAt || 'N/A',
              processedAt: doc?.processedAt || 'N/A',
              createdAt: doc?.createdTS || 'N/A',
              exception: doc.idp?.exception || 'N/A',
              images: doc.imgDetails?.imgPath || 'N/A',
              sequenceId: doc?.sequenceId || '-',
              range: rangeFromTo,
              isProcessed: doc?.isProcessed,
              isPublished: doc?.isPublished,
              boxStatus: eachBoxStatus[doc.activityId],
              isReprocess: doc?.isReprocess
            }
          })
          
          setHitlRejectCount(hitlRejectsData.length)
          setHitlRejectData(hitlRejectsData)
        } catch (error) {
          console.error('Error fetching HITL Rejects data:', error)
        }
      },
    },
    {
      label: t('jobStatusObj.IDP Failure'),
      columns: [
        {
          accessorKey: 'requestId',
          header: 'Request ID',
          Cell: ({ cell }) => {
            const dataIndex = cell.row.index
            const rowdata = currentTabData[dataIndex]
            return (
              <JobLink
                id={`myJobs_jobLink_${rowdata.requestId}`}
                theme={theme}
                to={{
                  pathname: `${routePaths.localactivityList}/${rowdata.requestId}`,
                  state: {
                    fromAdmin: false,
                    rowData: rowdata
                  }
                }}
              >
                {rowdata.requestId}
              </JobLink>
            )
          },
        },
        { header: t('tableColumns.userName'), accessorKey: 'username' },
        { header: t('tableColumns.customRequestName'), accessorKey: 'requestName' },
        { header:"Asset Type" , accessorKey:"assetType"},
        { header: t('tableColumns.boxNumber'), accessorKey: 'boxId' },
        { header: t('tableColumns.barcode'), accessorKey: 'barCode' },
        { header: t('smartCatalog.orderId'), accessorKey: 'orderId' },
        { header: t('tableColumns.status'), accessorKey: 'status' },
        { header: t('tableColumns.created'), accessorKey: 'createdAt' },
        { header: t('tableColumns.published'), accessorKey: 'publishedAt' },
        { header: t('tableColumns.processed'), accessorKey: 'processedAt' },
        { header: t('dashBoard.exception'), accessorKey: 'exception' },
        {
          accessorKey: 'images',
          header: t('tableColumns.images'),
          Cell: ({ row }) => {
            const rowData = row?.original?.images // assuming `images` is an array in each row
            if (rowData && rowData?.length !== 0) {
              return (
                <Visibility
                  style={{ cursor: 'pointer', fontSize: 32 }}
                  onClick={() => {
                    handleOpen(0, rowData)
                  }} 
                />
              )
            } else {
              return null
            }
          }
        },
        { 
          header: t('smartCatalog.sequenceId'), 
          accessorKey: 'sequenceId',
          enableFiltering: true,
          filterVariant: 'multi-select', // Matches filterType: 'multiselect'
          sortingFn: (rowA, rowB) => {
            const valueA = rowA.original.sequenceId === '-' ? Infinity : rowA.original.sequenceId
            const valueB = rowB.original.sequenceId === '-' ? Infinity : rowB.original.sequenceId
            return valueA - valueB
          },
          muiTableBodyCellProps: {
            sx: {
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            },
          },
        },
        { 
          header: t('smartCatalog.range'), 
          accessorKey: 'range',
          enableFiltering: true,
          filterVariant: 'multi-select', // Matches filterType: 'multiselect'
          muiTableBodyCellProps: {
            sx: {
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            },
          },
        },
        enableOptions
          ? {
              accessorKey: 'modify',
              header: t('tableColumns.action'),
              Cell: ({ cell }) => {
                const dataIndex = cell.row.index
                const rowData = currentTabData[dataIndex]
                if (!rowData) return null
                const isReprocess = rowData?.isReprocess ?? false
                let customMenuItems = []
                if (rowData && 
                  (
                    (!rowData?.isProcessed  && rowData?.isPublished ) || 
                    (['pending', 'In Progress'].includes(rowData?.boxStatus)) ||
                    (isReprocess)
                  )) {
                  customMenuItems = menuItems2
                } else {
                  customMenuItems = menuItems
                }
                return (
                  <MenuButton
                    id={'allJobs_ellipsis'}
                    buttonIcon={<MoreVert />}
                    rowdata={rowData}
                    items={customMenuItems}
                    onSelect={(value) => { onSelect(value, rowData) }}
                  />
                )
              }
            }
          : null
      ].filter(Boolean),
      fetchData: async () => {
        try {
          let result
          if (idpFailData.length === 0) {
            result = await localGdeTransactions.getrequestIdbydistandStatus(
              district, building,
              ['IDP Failure']
            )
          } else {
            result = idpFailData
          }
          
          // Run box status and request name lookups in parallel
          const boxPromise = result['IDP Failure'].Filtereddocs.map(doc => {
            const actId = doc.activityId
            return localGdeTransactions.getActivityByID(doc.activityId).then((res) => ({
              activityId: actId,
              status: res?.status
            }))
          })
          
          // Get unique request IDs to batch lookup
          const uniqueRequestIds = [...new Set(result['IDP Failure'].Filtereddocs.map(doc => doc?.requestId).filter(Boolean))]
          
          // Batch fetch all request names in parallel
          const requestNamePromises = uniqueRequestIds.map(requestId => 
            localGdeTransactions.getCustomRequestNameById(requestId).then(name => ({ requestId, name }))
          )
          
          // Wait for both in parallel
          const [allData, requestNames] = await Promise.all([
            Promise.all(boxPromise),
            Promise.all(requestNamePromises)
          ])
          
          // Create a map for quick lookup
          const requestNameMap = {}
          requestNames.forEach(({ requestId, name }) => {
            requestNameMap[requestId] = name
          })
          
          const eachBoxStatus = {}
          allData.forEach(e => {
            eachBoxStatus[e.activityId] = e.status
          })
          
          // Build data synchronously using the map
          const idpFailuresData = result['IDP Failure'].Filtereddocs.map((doc) => {
            const rangeFromTo = doc?.rangeFrom !== undefined && doc?.rangeTo !== undefined
              ? `${doc?.rangeFrom} - ${doc?.rangeTo}`
              : '-'
            return {
              activityId: doc.activityId,
              requestId: doc?.requestId || 'N/A',
              imageId: doc.id,
              customer: doc?.accountLevel1,
              assetType: doc?.assetType ||"N/A",
              currentImageURL: doc?.imgReference,
              username: doc?.username || 'N/A',
              requestName: requestNameMap[doc?.requestId] || 'N/A',
              boxId: doc?.skpBoxNbr || 'N/A',
              barCode: doc?.barcode || 'N/A',
              orderId: doc?.orderId || 'N/A',
              idpstatus: doc?.idp.status || 'N/A',
              exception: doc.idp?.exception || 'N/A',
              publishedAt: doc?.publishedAt || 'N/A',
              processedAt: doc?.processedAt || 'N/A',
              createdAt: doc?.createdTS || 'N/A',
              status: doc?.status || 'N/A',
              images: doc.imgDetails?.imgPath || 'N/A',
              sequenceId: doc?.sequenceId || '-',
              range: rangeFromTo,
              isProcessed: doc?.isProcessed,
              isPublished: doc?.isPublished,
              boxStatus: eachBoxStatus[doc.activityId],
              isReprocess: doc?.isReprocess
            }
          })
          
          setIdpFailureCount(idpFailuresData.length)
          setIdpFailureData(idpFailuresData)
        } catch (error) {
          console.error('Errors fetching IDP Failure data:', error)
        }
      },
    },
    {
      label: t('tableColumns.format'),
      columns: [
        {
          accessorKey: 'requestId',
          header: 'Request ID',
          Cell: ({ cell }) => {
            const dataIndex = cell.row.index
            const rowdata = currentTabData[dataIndex]
            return (
              <JobLink
                id={`myJobs_jobLink_${rowdata.requestId}`}
                theme={theme}
                to={{
                  pathname: `${routePaths.localactivityList}/${rowdata.requestId}`,
                  state: {
                    fromAdmin: false,
                    rowData: rowdata
                  }
                }}
              >
                {rowdata.requestId}
              </JobLink>
            )
          },
        },
        { header: t('tableColumns.userName'), accessorKey: 'username' },
        {
          header: t('tableColumns.format'),
          accessorKey: 'formartError',
          Cell: ({ cell }) => {
            const dataIndex = cell.row.index
            const rowData = currentTabData[dataIndex]
            if (rowData && rowData?.length !== 0) {
              return (
                <Button
                  onClick={() => showRequestList(rowData, false)}
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ margin: '0 0 0 4px' }}
                >
                  {t('buttons.yes')}
                </Button>
              )
            } else {
              return null
            }
          }
        },
        {
          header: t('tableColumns.customRequestName'),
          accessorKey: 'requestName',
        },
        { header:"Asset Type" , accessorKey:"assetType"},
        {
          header: t('tableColumns.boxNumber'),
          accessorKey: 'boxId',
          Cell: ({ cell }) => {
          const dataIndex = cell.row.index
          const rowData = currentTabData[dataIndex]
          if (rowData && rowData?.length !== 0) {
            return (
              <Button
                onClick={() => showRequestList(rowData, true)}
                variant="text"
                color="primary"
                size="small"
                style={{ margin: '0 0 0 4px' }}
              >
                {rowData.boxId}
              </Button>
            )
          } else {
            return null
          }
        }
        },
        { header: t('tableColumns.barcode'), accessorKey: 'barCode' },
        { header: t('smartCatalog.orderId'), accessorKey: 'orderId' },
        { header: t('tableColumns.status'), accessorKey: 'status' },
        { header: t('tableColumns.created'), accessorKey: 'createdAt' },
        { header: t('tableColumns.published'), accessorKey: 'publishedAt' },
        { header: t('tableColumns.processed'), accessorKey: 'processedAt' },
        { header: t('dashBoard.exception'), accessorKey: 'exception' },
        {
          accessorKey: 'images',
          header: t('tableColumns.images'),
          Cell: ({ row }) => {
            const rowData = row?.original?.images // assuming `images` is an array in each row
            if (rowData && rowData?.length !== 0) {
              return (
                <Visibility
                  style={{ cursor: 'pointer', fontSize: 32 }}
                  onClick={() => {
                    handleOpen(0, rowData)
                  }} 
                />
              )
            } else {
              return null
            }
          }
        },
        { 
          header: t('smartCatalog.sequenceId'), 
          accessorKey: 'sequenceId',
          enableFiltering: true,
          filterVariant: 'multi-select', // Matches filterType: 'multiselect'
          sortingFn: (rowA, rowB) => {
            const valueA = rowA.original.sequenceId === '-' ? Infinity : rowA.original.sequenceId
            const valueB = rowB.original.sequenceId === '-' ? Infinity : rowB.original.sequenceId
            return valueA - valueB
          },
          muiTableBodyCellProps: {
            sx: {
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            },
          },
        },
        { 
          header: t('smartCatalog.range'), 
          accessorKey: 'range',
          enableFiltering: true,
          filterVariant: 'multi-select', // Matches filterType: 'multiselect'
          muiTableBodyCellProps: {
            sx: {
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            },
          },
        },
        enableOptions
          ? {
              accessorKey: 'modify',
              header: t('tableColumns.action'),
              Cell: ({ cell }) => {
                const dataIndex = cell.row.index
                const rowData = currentTabData[dataIndex]
                if (!rowData) return null
                return (
                  <MenuButton
                    id={'allJobs_ellipsis'}
                    buttonIcon={<MoreVert />}
                    rowdata={rowData}
                    items={menuItems}
                    onSelect={(value) => { onSelect(value, rowData) }}
                  />
                )
              }
            }
          : null
      ].filter(Boolean),
      fetchData: async () => {
        try {
          let result
          if (formatData.length === 0) {
            result = await localGdeTransactions.getImagesByDistrictandFormat(district, building)
          } else {
            result = formatData
          }
          // Get unique request IDs to batch lookup
          const uniqueRequestIds = [...new Set(result.map(doc => doc?.requestId).filter(Boolean))]
          
          // Batch fetch all request names in parallel
          const requestNamePromises = uniqueRequestIds.map(requestId => 
            localGdeTransactions.getCustomRequestNameById(requestId).then(name => ({ requestId, name }))
          )
          
          const requestNames = await Promise.all(requestNamePromises)
          
          // Create a map for quick lookup
          const requestNameMap = {}
          requestNames.forEach(({ requestId, name }) => {
            requestNameMap[requestId] = name
          })
          
          // Build data synchronously using the map
          const failData = result.map((doc) => {
            const rangeFromTo = doc?.rangeFrom !== undefined && doc?.rangeTo !== undefined
              ? `${doc?.rangeFrom} - ${doc?.rangeTo}`
              : '-'
            return {
              activityId: doc?.activityId,
              requestId: doc?.requestId || 'N/A',
              imageId: doc?.id,
              customer: doc?.accountLevel1,
              assetType: doc?.assetType,
              formatError: doc?.formatError.toString(),
              currentImageURL: doc?.imgReference,
              username: doc.username || 'N/A',
              requestName: requestNameMap[doc?.requestId] || 'N/A',
              boxId: doc.skpBoxNbr || 'N/A',
              barCode: doc?.barcode || 'N/A',
              orderId: doc.orderId || 'N/A',
              status: t(`jobStatusObj.${doc?.status}`) || 'N/A',
              processedAt: doc?.processedAt || 'N/A',
              createdAt: doc.createdTS || 'N/A',
              publishedAt: doc.publishedAt || 'N/A',
              exception: doc.idp?.exception || 'N/A',
              images: doc.imgDetails?.imgPath || 'N/A',
              sequenceId: doc?.sequenceId || '-',
              range: rangeFromTo,
            }
          })
          
          setFailCount(failData.length)
          setFailData(failData)
        } catch (error) {
          console.error('Error fetching Format error data:', error)
        }
      },
    },

  ]
  const ButtonsForTemplateAssign = props =>
      <>
        <CancelButton id={'addBoxTransmittal_button_cancel'} onClick={props.handleCancel} />
        <XDivider width='10px' />
      </>

    const showRequestList = async (rowData, isBoxIdClicked) => {
        // story 1474 :: added new flag isBoxIdClicked to differentiate between format error for image & entire box
         const imageDocs = isBoxIdClicked ? await localGdeTransactions.getSelectedResponse(rowData.activityId, false) : await localGdeTransactions.getImagesFormat(rowData?.imageId)
        const constructUserFields = (imageDocs) => {
          const templateDatano = Object.values(imageDocs[0]?.template).map(item => item.fieldId)
          let templateDatalo = []
          if (imageDocs[0]?.templateLocked) {
          templateDatalo = Object.values(imageDocs[0]?.templateLocked).map(item => item.fieldId)
          }
          const templateData = [...templateDatano, ...templateDatalo]
          // const templateData = Object.values(imageDocs[0]?.template).map(item => item.fieldId)
          let columnsResponse = []
    
          columnsResponse =
            templateData.map((item) => ({
              header: item,
              accessorKey: item,
              Cell: ({ cell, row }) => {
                const fieldName = item
                const errors = row.original.errors || {}
                return (
                  <div>
                    <span>
                      {cell.getValue()}
                    </span>
                    {errors[fieldName] && (
                      <div style={{ color: 'red', fontSize: '0.8em' }}>
                        {errors[fieldName]}
                      </div>
                    )}
                  </div>
                )
              }
            }))
          columnsResponse = columnsResponse.map((col) => {
            const headerLength = col.header.length
            let minWidth = 0
            if (headerLength < 8) {
              minWidth = headerLength * 8
            } else {
              minWidth = headerLength * 15
            }
            return {
              ...col,
              minSize: minWidth,
              muiTableHeadCellProps: {
                sx: {
                  whiteSpace: 'nowrap',
                  wordWrap: 'break-word',
                  minWidth: `${minWidth}px`,
                  overflow: 'visible',
                  color: '#58595B',
                  fontWeight: 'bold',
                },
              },
              muiTableBodyCellProps: {
                sx: {
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                }
              },
            }
          })
          setState({ columnsNew: columnsResponse })
          return imageDocs.flatMap((box) => {
            if (!box.idpResponse) {
              return []
            }
            if (!box.formatError) {
              return []
            }
            const processFields = (fields, folder, isLocked) => {
              return Object.entries(fields).reduce((result, [fieldName, fieldData]) => {
                const { fieldId } = fieldData
                if (box.idpResponse[folder]) {
                  result[fieldId] = isLocked
                    ? fieldData.lockedValue
                    : box.idpResponse[folder][fieldName] || ''
  
                  const error = box?.formatErrorInfo?.[folder]?.[fieldName]
                  if (error) {
                    result.errors = { ...result.errors, [fieldId]: error }
                  }
                  // result.boxId = box.skpBoxNbr
                }
                return result
              }, {})
            }
    
            return Object.keys(box.idpResponse)
              .sort()
              .map((folder) => {
                const userFields1 = processFields(box?.template, folder, false)
                const userFields2 = processFields(box?.templateLocked, folder, true)
                return { ...userFields1, ...userFields2 }
              })
          })
        }
    
        const responseData = constructUserFields(imageDocs)
    
        openGeneralDialog({
          title: t('routeTitles.responseDetails'),
          maxWidth: 'lg',
          noTranslateTitle: true,
          message: <ContentForDialogBox columns={getState()?.columnsNew} columnsData={responseData} />,
          buttons: <ButtonsForTemplateAssign handleCancel={handleCancel} />,
          closeX: true
        })
      }
     const ContentForDialogBox = (props) => {
        const normalData = props.columnsData
        const normalColumns = props.columns
        const columnsResponse = normalColumns.filter((col) =>
          normalData.some((row) => {
            const hasdata = row[col.accessorKey] !== '' && row[col.accessorKey] !== undefined && row[col.accessorKey] !== null
            const hasError = row.errors?.[col.accessorKey] && row.errors[col.accessorKey] !== ''
            return hasdata || hasError
          })
        )
        const responseData = normalData.filter((row) =>
          row.errors !== undefined
        )
    
        return (
          <MaterialReactTable
            columns={columnsResponse}
            data={responseData}
            enableColumnFilters={true}
            enableRowSelection
            enableExport={true}
            enableGlobalFilter
            enableColumnFilter
            enableColumnSorting
            enableGrouping={true}
            enableColumnResizing={true}
            muiTableHeadCellProps={{
              sx: {
                color: '#58595B',
                fontWeight: 'bold',
              },
            }}
            initialState={{
              density: 'compact'
            }}
            renderTopToolbarCustomActions={({ table, data }) => {
              const isDisabled = !table.getIsSomeRowsSelected()
              const isNoData = responseData?.length === 0
              const isNoPageData = responseData?.length > 4
              return (
                <ExportCsv
                  columns={columnsResponse}
                  isDisabled={isDisabled}
                  isNoData={isNoData}
                  isNoPageData={isNoPageData}
                  table={table}
                />
              )
            }}
            tableFor={'smart_catalog'}
          />
        )
      }
      const handleCancel = () => {
          closeGeneralDialog()
        }
  // const fetchData = async (isInitialFetch) => {
  //   try {
  //     // Show loading indicator only during the first fetch
  //     if (isInitialFetch) {
  //       setIsLoading(true);
  //     }
  //     for (let i = 0; i < tabConfigs.length; i++) {
  //       await tabConfigs[i].fetchData(); // Assuming this function fetches data for each tabConfig
  //     } 
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   } finally {
  //     // Stop loading indicator only for the first fetch
  //     if (isInitialFetch) {
  //       setIsLoading(false)
  //     }
  //   }
  // };
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const fetchPromises = tabConfigs.map(tabConfig => tabConfig.fetchData());
      await Promise.all(fetchPromises); // Wait for all fetches to complete
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false)
    }
  }
  
  useEffect(async () => {
    fetchData()
    const unsubscribe = await localGdeTransactions.getRequestIdByDistAndStatusListener(setIdpFailData, district, building,
      ['IDP Failure'])
    return () => unsubscribe()
  }, [district, building])

  
  useEffect(async () => {
    fetchData()
    const unsubscribe = await localGdeTransactions.getRequestIdByDistAndStatusListener(setIdpData, district, building,
      ['HITL Reject'])
    return () => unsubscribe()
  }, [district, building])

  useEffect(async () => {
    fetchData()
    const unsubscribe = await localGdeTransactions.getImagesByDistrictandFormatListener(setFormatData, district, building)
    return () => unsubscribe()
  }, [district, building])
  useEffect(async () => {
    fetchData()
  }, [idpData, idpFailData, formatData])

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const currentTabData = [
    hitlRejectData,
    idpFailureData,
    failData,
  ][activeTab]
  const tabConfigsWithResizing = tabConfigs.map(tabConfig => ({
    ...tabConfig,
    columns: tabConfig.columns.map((col) => {
      const headerLength = col.header.length
      let minWidth = 0
      if (headerLength < 8) {
        minWidth = headerLength * 8
      } else {
        minWidth = headerLength * 15
      }

      return {
        ...col,
        minSize: minWidth,
        enableResizing: true,
        muiTableHeadCellProps: {
          sx: {
            whiteSpace: 'nowrap',
            wordWrap: 'break-word',
            minWidth: `${minWidth}px`,
            overflow: 'visible',
            color: '#58595B',
            fontWeight: 'bold',
          }
        },
        muiTableBodyCellProps: {
          sx: {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }
        },
      }
    })
  }))
  // const tabConfigsWithResizing = tabConfigs.map(tabConfig => ({
  //   ...tabConfig,
  //   columns: tabConfig.columns.map(col => ({
  //     ...col,
  //     enableResizing: true,
  //     minWidth: 150,
  //   })),
  // }))
  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
        <IconButton onClick={handleGoBack} color="primary" sx={{ marginRight: 2 }}>
          <ArrowBack />
        </IconButton>
        <Tabs value={activeTab} onChange={handleTabChange} aria-label="Data Tabs" TabIndicatorProps={{ style: { display: 'none' } }}>
          {tabConfigs.map((tab, index) => (
            <Tab
              key={index}
              label={
                <Box display="flex" alignItems="center">
                  <Typography>{tab.label}</Typography>
                  <Box style={{ backgroundColor: '#6BA1CF', color: 'white', marginLeft: 4, padding: '2px 6px', borderRadius: '4px' }}>
                    {index === 0 && hitlRejectCount}
                    {index === 1 && idpFailureCount}
                    {index === 2 && failCount}
                  </Box>
                </Box>
              }
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflowX: 'auto' }}>
        <MaterialReactTable
          data={currentTabData}
          columns={tabConfigsWithResizing[activeTab].columns}
          state={{ showSkeletons: isLoading }}
          muiTableHeadCellProps={{
            sx: {
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'left',
              minWidth: 200
            }
          }}
          muiTableBodyCellProps={{
            sx: {
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              minWidth: 200,
            }
          }}
          muiTableProps={{
            sx: {
              tableLayout: 'auto',
              width: '100%',
              minWidth: 200
            },
          }}
          renderTopToolbarCustomActions={({ table, data }) => {
            const isDisabled = !table.getIsSomeRowsSelected()
            const isNoData = currentTabData?.length === 0
            const isNoPageData = currentTabData?.length > 4
            const hideExportSelectedData = true
            return (
              <ExportCsv
                columns={tabConfigsWithResizing[activeTab].columns}
                isDisabled={isDisabled}
                isNoData={isNoData}
                isNoPageData={isNoPageData}
                hideExportSelectedData={hideExportSelectedData}
                table={table}
              />
            )
          }}
          enableGlobalFilter
          enablePagination
          enableSorting
          enableColumnFilter
          enableColumnSorting
          enableGrouping={true}
          enableColumnResizing={true}  
          defaultColumnMinWidth={150}  
        />
      </Box>
      <MultiImageContainer />
      {retakeImage && <RetakeImageBox rowData={selectedRowData} onClose={handleCloseRetakeImageModal} />}
      {openReprocessImage && <ReprocessImage rowData= {selectedRowData} onClose={handleCloseMenuItems}/> }
      {openTemplateModal && <UpdateImageTemplate rowData= {selectedRowData} onClose={handleCloseTemplateModal}/> }
      {openChangeRefImg && <UpdateImgRefImage rowData={selectedRowData} onClose={handleCloseRefImgModal} />}
      {openChangeTempAndRefImg && <UpdateImageTemplateAndRef rowData={selectedRowData} onClose={handleCloseRefImgandTempModal} />}
    </Box>
  )
}